import React, { Suspense } from 'react';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import FiltersSkeleton from '../FiltersSkeleton';

const FiltersPanel = React.lazy(
  () =>
    import(/* webpackChunkName: "FiltersPanel" */ './components/FiltersPanel'),
);

const FiltersPanelMobile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FiltersPanelMobile" */ './components/FiltersPanelMobile'
    ),
);

type Props = {
  isHotelOnly: boolean;
  show: boolean;
  isMobile?: boolean;
};

const LazyFilters = ({ isHotelOnly, show, isMobile }: Props) => {
  if (!show && !isMobile) {
    return <FiltersSkeleton />;
  }

  return (
    <ErrorBoundary showDialog={false}>
      <Suspense fallback={<FiltersSkeleton isMobile={isMobile} />}>
        {isMobile ? (
          <FiltersPanelMobile isHotelOnly={isHotelOnly} />
        ) : (
          <FiltersPanel isHotelOnly={isHotelOnly} />
        )}
      </Suspense>
    </ErrorBoundary>
  );
};

export default LazyFilters;
